import React, { Component } from 'react';
import { MuiGrid, MuiTypography, MuiButton, MuiReportProblemIcon, MuiHomeIcon } from './components/ui/MaterialUIComponents';
import theme from './assests/theme'
import { getKeyFromLS } from './utils/LocalStorageUtil'
class ErrorBoundary extends Component {

    constructor(props) {
        super(props);
        this.state = {
            hasError: false,
            info: '',
            error: ''
        };
    }

    componentDidCatch(error, info) {
        let i18n = getKeyFromLS("i18n");
        this.setState({ hasError: true, info, error, i18n: i18n });
        console.log(`Error: ${error}`);
        console.log(`ErrorInfo: ${JSON.stringify(info)}`);

    }

    render() {
        return this.state.hasError ?
            <MuiGrid container xs={12} justify="center" alignItems="center" style={{ height: "100vh", background: theme.palette.grey.light }}>

                <MuiGrid xs={12} align="center" style={{ background: theme.palette.grey.light }}>
                    <MuiGrid xs={12}>
                        <MuiReportProblemIcon style={{ color: theme.palette.grey.darker, fontSize: 100 }} />
                    </MuiGrid>
                    <MuiGrid xs={12}>
                        <MuiTypography variant="h4" color="textSecondary" gutterBottom> {this.state.i18n.errorBoundary.errorMessage} </MuiTypography>
                    </MuiGrid>

                    <MuiGrid xs={12} justify="center" alignItems="center">
                        <MuiButton href={window.location.origin}
                            style={{ color: theme.palette.grey.darker }}
                            startIcon={<MuiHomeIcon style={{ color: theme.palette.grey.darker, textTransform: "none" }} />}
                        >
                            {this.state.i18n.errorBoundary.redirectText}
                        </MuiButton>
                    </MuiGrid>
                </MuiGrid ></MuiGrid >

            : this.props.children;
    }
}

export default ErrorBoundary;